<script lang="ts" setup>
import {
  EvaluationCriteria,
  EvaluationResults,
} from "@/types/EvaluationResults";
import { EvaluationMetric } from "types/EvaluationMetric";

const props = defineProps({
  evaluationResults: {
    type: Object as PropType<EvaluationResults>,
    required: true,
  },
});

const evaluationMetric = ref<EvaluationMetric | undefined>(undefined);

const overrideDefinition = computed(() => {
  return (id: string) => {
    return evaluationMetric.value?.overrides[id];
  };
});

const allValues = ref<string[]>([]);
const wordsToIgnore = ref<string[]>([]);

const extractValues = () => {
  allValues.value = [];
  wordsToIgnore.value = [];

  if (!props.evaluationResults) return;

  if (!props.evaluationResults.evaluationResult) return;

  for (var criteria of props.evaluationResults.evaluationResult ?? []) {
    extractValuesFromCriteria.value(criteria);
  }

  wordsToIgnore.value.sort((a, b) =>
    a.toLowerCase().localeCompare(b.toLowerCase())
  );
};

onMounted(() => {
  extractValues();
});

const extractValuesFromCriteria = computed(() => {
  return (evaluationCriteria: EvaluationCriteria) => {
    if (Object.keys(evaluationCriteria.options).includes("values")) {
      allValues.value.push(...evaluationCriteria.options["values"]);
    }

    if (Object.keys(evaluationCriteria.options).includes("wordsToIgnore")) {
      wordsToIgnore.value.push(...evaluationCriteria.options["wordsToIgnore"]);
    }

    for (var criteria of evaluationCriteria.criteria ?? []) {
      extractValuesFromCriteria.value(criteria);
    }
  };
});
</script>

<template>
  <div class="h-full flex flex-col p-2 border-2 rounded mb-2">
    <div class="flex flex-col mb-4" v-if="allValues.length > 0">
      <span class="font-bold"> List of flagged items </span>
      <div class="flex flex-col px-2">
        <span v-for="(item, itemKey) in allValues" :key="itemKey">
          {{ item }}
        </span>
      </div>
    </div>
    <div class="flex flex-col" v-if="wordsToIgnore.length > 0">
      <span class="font-bold"> List of Words to Ignore </span>
      <div class="flex flex-col px-2">
        <span v-for="(item, itemKey) in wordsToIgnore" :key="itemKey">
          {{ item.toLowerCase() }}
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
